const setOverlapHeight = (form) => {
	let root = document.documentElement;
	let header = document.querySelector('#header-section');

	if ( !header ) {
		return;
	}

	let offset = header.clientHeight * -1;
	root.style.setProperty('--form--overlap', offset + 'px');
}

window.onload = function () {

	let form = document.querySelector('.form-box-wrap');

	if ( !form ) {
		return;
	}

	setOverlapHeight(form);

	window.addEventListener('resize', debounce(setOverlapHeight, 100));

	// Wait one second and try it again. On some pages that don't use the full header
	// the form overlap is set before all the elements are in place.
	setTimeout( () => {
		setOverlapHeight();
	}, 1000 );
};

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
	let timeout;
	return function () {
		let context = this, args = arguments;
		let later = function () {
			timeout = null;
			if (!immediate) {
				func.apply(context, args);
			}
		};
		let callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) {
			func.apply(context, args);
		}
	}
}